import { isAuthBypassEnabled } from './dev-auth'

export const isAccountV2SandboxSimEnabled = (): boolean =>
  import.meta.env.VITE_ACCOUNT_V2_SANDBOX_SIM === '1' &&
  import.meta.env.VITE_TEST_AUTH === '1' &&
  import.meta.env.VITE_USE_MOCKS !== '1'

export const isDevSimRouteEnabled = (): boolean =>
  isAuthBypassEnabled() || isAccountV2SandboxSimEnabled()
